import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SearchService } from '../shared/searchservice';
import { Router } from '@angular/router';
import { RouterLinkRendererComponent } from './routerlinkrenderer.component';

@Component({
    selector: 'app-searchresult-component',
    templateUrl: './searchresult.component.html',
    styleUrls: ['searchresult.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchResultComponent {
  serviceResult: any;
  rowData: any = [];
  columnDefs: any = [
    {
      headerName: 'Reference Number', field: 'claimId', /*cellRenderer: (claimId) =>
        `<a [routerLink]="/claim/${claimId.value}" >Details</a>`*/

      cellRenderer: RouterLinkRendererComponent, sortable: true
    },
    { headerName: 'Claim Number', field: 'referenceNumber', cellRenderer : function(params){
      if(params.value == "0" || params.value == null)
      return '';
      else return params.value;
      }, sortable: true },
    { headerName: 'Policy Number', field: 'policyNumber', tooltip: (params) => params.value, sortable: true },
    { headerName: 'Insured Name', field: 'insuredName', tooltip: (params) => params.value, sortable: true },
    { headerName: 'Contact Name', field: 'contactName', sortable: true },
    { headerName: 'Status', field: 'status', tooltip: (params) => params.value, sortable: true },
    { headerName: 'Received Date', field: 'receivedDate', sortable: true, comparator: this.dateComparator },
    { headerName: 'Adjuster', field: 'adjuster', tooltip: (params) => params.value, sortable: true },
    { headerName: 'Source', field: 'source', tooltip: (params) => params.value, sortable: true }
  ];
  constructor(private searchService: SearchService, private router: Router) {
    if (this.router.getCurrentNavigation().extras.state !== undefined) {
      this.rowData = this.router.getCurrentNavigation().extras.state.searchResult.result;
    }
    else {
      let lastSearchResult = sessionStorage.getItem('lastSearchResult');
      if (lastSearchResult !== null) {
        this.rowData = JSON.parse(lastSearchResult).result;
      }
      else {
        this.rowData = [];
      }
    }
  }

  ngOnInit() {
  }
  
  onGridReady(params) {
    params.api.sizeColumnsToFit();
  }

  dateComparator(date1, date2) {
  var date1Number = date1 && new Date(date1).getTime();
  var date2Number = date2 && new Date(date2).getTime();

  if (date1Number == null && date2Number == null) {
    return 0;
  }

  if (date1Number == null) {
    return -1;
  } else if (date2Number == null) {
    return 1;
  }

  return date1Number - date2Number;
}

}
